import CaretDownOutlined from '@ant-design/icons/CaretDownOutlined';
import { Select, Tooltip } from 'antd';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import Selection from './Selection';

const ToolbarSelection = ({
  isRadio,
  isAction,
  //
  bState,
  //
  groupId,
  primary: _primary,
  secondary,
  items: _items,
  renderer,
  onInteraction,
  disabled,
}) => {
  const { t } = useTranslation('Buttons');

  const handleChange = (id) => {
    const item = _items.find((it) => it?.id === id);
    onInteraction({
      groupId,
      //
      itemId: item.id,
      interactionType: item.type,
      // splitButtonId? (so we can track group?)
      // info to fire item's command/event?
      commands: item.commands,
    });

  };
  const selectedItem =
    _items.find(
      (it) => it?.id == bState?.groups?.[groupId] && !!bState?.toggles?.[it?.id]
    ) || _primary;

  return (
    <div className="relative mx-1.5 flex">
      {/* <Tooltip title={_primary.tooltip} placement="top"> */}
      <Selection
        size="small"
        menuItemSelectedIcon={null}
        suffixIcon={<CaretDownOutlined className="text-sm" />}
        value={selectedItem?.id}
        onChange={handleChange}
        disabled={disabled}
        style={{ background: 'transparent' }}
        dropdownMatchSelectWidth={false}
      >
        {_items.map((it) => (
          <Select.Option key={it.id} value={it.id}>
            {it.label}
          </Select.Option>
        ))}
      </Selection>
      {/* </Tooltip> */}
    </div>
  );
};

ToolbarSelection.defaultProps = {
  isRadio: false,
  isAction: false,
  primary: {
    label: null,
    tooltip: null,
  },
  secondary: {
    icon: 'chevron-down',
    label: null,
    isActive: true,
    tooltip: 'More Measure Tools',
  },
  items: [],
};

ToolbarSelection.propTypes = {
  primary: PropTypes.shape({
    id: PropTypes.string.isRequired,
    icon: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.oneOf(['tool', 'action', 'toggle']).isRequired,
    tooltip: PropTypes.string,
  }),
  secondary: PropTypes.shape({
    id: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    isActive: PropTypes.bool,
  }),
  renderer: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: PropTypes.string,
      label: PropTypes.string,
      type: PropTypes.oneOf(['tool', 'action', 'toggle']).isRequired,
      tooltip: PropTypes.string,
      isActive: PropTypes.bool,
    })
  ),
  /** Callback function to inform ToolBarService of important events */
  onInteraction: PropTypes.func.isRequired,
};

export default ToolbarSelection;
